import { render, staticRenderFns } from "./MyColorPicker.vue?vue&type=template&id=88146f66&scoped=true&"
import script from "./MyColorPicker.vue?vue&type=script&lang=js&"
export * from "./MyColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./MyColorPicker.vue?vue&type=style&index=0&id=88146f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88146f66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VColorPicker,VDialog})
